const Crm = {
    textStyle: {
        margin: '52px 28px 41px ',
        fontFamily: 'Kalameh',
        fontSize: '17.5px',
        lineHeight: '32px',
        textAlign: "center",
        color: '#707070',
    },
    input: {
        width: '200px',
        margin: '0 auto ',
        padding: '7.2px',
        borderRadius: '100px',
        boxShadow: '-4px -4px 15px 0 #ffffff, 4px 4px 15px 0 rgba(172, 172, 172, 0.5)',
        border: 'solid 1px #ffffff',
        backgroundColor: '#F5F5F5',
    },
    number: {
        fontFamily: 'Kalameh',
        fontSize: '21px',
        fontWeight: 'bold',
        textAlign: 'center',
        color: '#707070',
    },
    back: {
        width: '200px',
        textAlign: 'center',
        margin: '0 auto 0',
        padding: '9px 0',
        borderRadius: '16px',
        boxShadow: '-4px -4px 15px 0 #ffffff, 4px 4px 15px 0 rgba(172, 172, 172, 0.5)',
        border: 'solid 1px #ffffff',
        backgroundColor: '#F5F5F5',
        cursor: 'pointer',
    },
    backText: {
        fontFamily:'dana',
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#753cbe',
    }

};
export default Crm;